import "./SelectPeriodField.scss";
import { Field, FieldProps } from "formik";
import * as React from "react";
import FormFieldWrapper from "../../Forms/FormFieldWrapper";
import CustomSelect from "../../Forms/CustomSelect";
import {
  Button,
  ButtonGroup,
  InputGroup,
  InputGroupAddon,
  UncontrolledTooltip,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCompressAlt, faExpandAlt } from "@fortawesome/free-solid-svg-icons";
import config from "../../../config";

const getLabel = (options: { label: any; value: any }[], value: any) => {
  const option = options.find((x) => x.value === value);
  return option && option.label;
};

const SelectPeriodField = ({
  name,
  nameExtended,
  title,
  placeholder,
  colSize,
  options,
  optionsFull,
  autoFocus,
  disabled,
  extended,
  onSelectPeriod,
}: {
  name: string;
  nameExtended: string;
  title: string;
  placeholder?: string;
  colSize: number;
  options: { label: any; value: any }[];
  optionsFull: { label: any; value: any }[];
  autoFocus?: boolean;
  disabled?: boolean;
  extended?: boolean;
  onSelectPeriod?: (period: number, extended: boolean) => void;
}) => {
  const [compressed, setCompressed] = React.useState(!extended);

  return (
    <>
      <Field name={name}>
        {({ field, form }: FieldProps<any>) => {
          return (
            <FormFieldWrapper
              title={title}
              colSize={colSize}
              field={field}
              form={form}
            >
              <InputGroup>
                {config.TERM_CHOICE && (
                  <InputGroupAddon addonType="prepend">
                    <UncontrolledTooltip
                      placement="top"
                      target="btnShowHide"
                      disabled={disabled}
                    >
                      {"Show " +
                        (compressed ? "extended" : "standard") +
                        " choices"}
                    </UncontrolledTooltip>
                    <ButtonGroup>
                      <Button
                        id={"btnShowHide"}
                        disabled={disabled}
                        color={compressed ? "secondary" : "primary"}
                        onClick={() => {
                          form.setFieldValue(nameExtended, compressed);
                          setCompressed(!compressed);
                          if (!compressed) {
                            const newVal = Math.round(field.value / 12) * 12;
                            if (newVal !== field.value) {
                              // Only fire events etc, if the value is genuinely changed
                              form.setFieldValue(field.name, newVal);
                              if (onSelectPeriod !== undefined)
                                onSelectPeriod(newVal, false);
                            }
                          }
                          form.setFieldTouched(field.name as any, true, false);
                          setTimeout(form.validateForm, 0);
                        }}
                      >
                        <FontAwesomeIcon
                          icon={compressed ? faExpandAlt : faCompressAlt}
                        />
                      </Button>
                    </ButtonGroup>
                  </InputGroupAddon>
                )}
                <CustomSelect
                  name={field.name}
                  className="select-period"
                  value={
                    field.value
                      ? {
                          label: getLabel(
                            compressed ? options : optionsFull,
                            field.value
                          ),
                          value: field.value,
                        }
                      : null
                  }
                  onChange={(option) => {
                    form.setFieldValue(
                      field.name as any,
                      (option as any).value,
                      false
                    );
                    form.setFieldTouched(field.name as any, true, false);
                    setTimeout(form.validateForm, 0);
                    if (onSelectPeriod !== undefined)
                      onSelectPeriod((option as any).value, !compressed);
                  }}
                  onBlur={() => form.setFieldTouched(field.name, true)}
                  options={compressed ? options : optionsFull}
                  placeholder={placeholder}
                  autoFocus={autoFocus}
                  isDisabled={disabled}
                />
              </InputGroup>
            </FormFieldWrapper>
          );
        }}
      </Field>
    </>
  );
};

export default SelectPeriodField;
